import { useSelector } from 'react-redux';
import State from 'store/State';

export const selectCurrency = (state: State, currencyCode: string) =>
    state.app.currencies[currencyCode];

export const useSelectCurrency = (currencyCode: string) =>
    useSelector(
        (state: State) => state.app.currencies[currencyCode.toUpperCase()]
    );
